
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.5 8.5s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5-7-5-7-5"}}),_c('path',{attrs:{"d":"M8.5 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"}})])])
          )
        }
      }
    